import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				backgroundColor: theme.palette.common.white,
				padding: "10px 16px"
			},
			rootItem: {
				"& > .MuiGrid-item": {
					padding: "0px !important"
				}
			},
			title: {
				fontSize: 18,
				fontWeight: 500,
				color: theme.palette.primary.contrastText,
				marginBottom: 10
			}
		}),
	{
		name: "Product",
		index: 1
	}
);

export default useStyles;
